var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16C14 15.4477 14.4477 15 15 15H28C28.5523 15 29 15.4477 29 16C29 16.5523 28.5523 17 28 17H15C14.4477 17 14 16.5523 14 16Z",
    fill: "#232840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 7.44772 14.4477 7 15 7H28C28.5523 7 29 7.44772 29 8C29 8.55229 28.5523 9 28 9H15C14.4477 9 14 8.55229 14 8Z",
    fill: "#232840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 24C14 23.4477 14.4477 23 15 23H28C28.5523 23 29 23.4477 29 24C29 24.5523 28.5523 25 28 25H15C14.4477 25 14 24.5523 14 24Z",
    fill: "#232840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6823 20.2689C12.0861 20.6458 12.1079 21.2786 11.7311 21.6823L7.06439 26.6823C6.87527 26.885 6.61052 27 6.33334 27C6.05616 27 5.79141 26.885 5.60228 26.6823L3.26895 24.1823C2.89211 23.7786 2.91393 23.1458 3.31769 22.7689C3.72144 22.3921 4.35422 22.4139 4.73106 22.8177L6.33334 24.5344L10.2689 20.3177C10.6458 19.9139 11.2786 19.8921 11.6823 20.2689Z",
    fill: "#232840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6823 12.2689C12.0861 12.6458 12.1079 13.2786 11.7311 13.6823L7.06439 18.6823C6.87527 18.885 6.61052 19 6.33334 19C6.05616 19 5.79141 18.885 5.60228 18.6823L3.26895 16.1823C2.89211 15.7786 2.91393 15.1458 3.31769 14.7689C3.72144 14.3921 4.35422 14.4139 4.73106 14.8177L6.33334 16.5344L10.2689 12.3177C10.6458 11.9139 11.2786 11.8921 11.6823 12.2689Z",
    fill: "#232840"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6823 4.26895C12.0861 4.64578 12.1079 5.27857 11.7311 5.68232L7.06439 10.6823C6.87527 10.885 6.61052 11 6.33334 11C6.05616 11 5.79141 10.885 5.60228 10.6823L3.26895 8.18232C2.89211 7.77857 2.91393 7.14578 3.31769 6.76895C3.72144 6.39211 4.35422 6.41393 4.73106 6.81769L6.33334 8.53441L10.2689 4.31769C10.6458 3.91393 11.2786 3.89211 11.6823 4.26895Z",
    fill: "#232840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.6081d0aa2a832348a0b04b402aca7e53.svg";
export { ForwardRef as ReactComponent };